import { restApi } from '../../api';
import {
  AnnouncementOutput,
  CreateAnnouncementInput,
  UpdateAnnouncementInput,
} from './announcements.types';

const PATH = 'announcements';

export const getCurrentAnnouncement = () =>
  restApi.get<AnnouncementOutput | null>(`${PATH}/current`);

export const findAnnouncements = () => restApi.get<AnnouncementOutput[]>(PATH);

export const getAnnouncementById = (announcementId: string) =>
  restApi.get<AnnouncementOutput>(`${PATH}/${announcementId}`);

export const createAnnouncement = (input: CreateAnnouncementInput) =>
  restApi.post<AnnouncementOutput>(PATH, input);

export const updateAnnouncement = (announcementId: string, input: UpdateAnnouncementInput) =>
  restApi.patch<AnnouncementOutput>(`${PATH}/${announcementId}`, input);

export const deleteAnnouncement = (announcementId: string) =>
  restApi.delete(`${PATH}/${announcementId}`);
